import { useEffect } from "react";

export default function Dashboard() {
  useEffect(() => {
    // checking the query string and search params
    const queryParams = new URLSearchParams(window.location.search);
    const parentCode = queryParams.get("parent_code");

    if (parentCode) {
      window.location.href =
        "https://parent.heroicgameday.com/dashboard/?parent_code=" + parentCode;
    } else {
      window.location.href = "https://parent.heroicgameday.com";
    }
  }, []);

  return <div>Loading...</div>;
}
